// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfigLive = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

const firebaseConfigTesting = {
  apiKey: process.env.REACT_APP_API_KEY_TEST,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN_TEST,
  projectId: process.env.REACT_APP_PROJECT_ID_TEST,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET_TEST,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID_TEST,
  appId: process.env.REACT_APP_APP_ID_TEST,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID_TEST,
};

export const app = initializeApp(firebaseConfigLive);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);
  